import { ElementsFactories } from 'react-planner';

const info = {
  title: 'T Shape',
  tag: ['shape'],
  description: 'T Shape',
  image: require('./area-t-shape.png')
};

export default ElementsFactories.AreaFactory('area-t', info);
